import { Injectable } from '@angular/core';
import { ModuleConfigService } from '../../../common/services/module-config/module-config.service';
import { HolUTCDisplay } from '../../../common/enums/hol-utc-display.enum';

@Injectable({
  providedIn: 'root',
})
export class EclModuleConfigService extends ModuleConfigService {
  public constructor() {
    super();
    this.config.localHours = false;
    this.config.utcDisplay = HolUTCDisplay.FORCE_UTC;
    this.config.showLinkToFlightOcc = false;
    this.config.moduleName = 'ecl';
    this.config.forceEventChecklistActivation = true;
    this.config.canCreateItemsFromLogbook = true;
    this.config.canCreateTags = true;
    this.config.logbooksOrder = 1;
    this.config.decisionsOrder = 2;
    this.config.eventsOrder = 3;
    this.config.flightsOrder = 4;
    this.config.canActivateEclModule = false;
    this.config.translateKey = 'ECL';
    this.config.canEditNi = true;
    this.config.canOpenFlight = false;
    this.config.forceEventNotification = true;
    this.config.activateEventNotification = true;
    this.config.rootPath = 'ecl';
    this.config.displayToERP = true;
    this.config.fastTypingModal = false;
  }
}
